var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m511.323 196.528v274.389c0 22.695-18.389 41.084-41.073 41.084h-337.487c-19.388 0-35.634-13.434-39.951-31.503l-.165-23.488-.957-139.879v-276.047c0-22.695 18.388-41.084 41.073-41.084h182.033c16.359 0 69.341 45.173 116.173 92.747 42.732 43.422 80.354 88.843 80.354 103.781z",
    fill: "#ddeafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.323 196.528v100.515c0-.113-.01-.227-.01-.35-3.091-123.333-103.554-129.04-136.406-161.893l56.062-42.052c42.732 43.421 80.354 88.842 80.354 103.78z",
    fill: "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.79 0h-100.514c.113 0 .227.01.35.01 123.333 3.091 129.04 103.554 161.893 136.406l42.052-56.062c-43.422-42.732-88.843-80.354-103.781-80.354z",
    fill: "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.323 196.533v17.377c0-36.586-29.667-66.253-66.253-66.253h-40.324c-22.684 0-41.081-18.397-41.081-41.081v-40.323c0-36.586-29.667-66.253-66.253-66.253h17.377c31.29 0 61.308 12.433 83.433 34.557l78.543 78.543c22.125 22.125 34.558 52.143 34.558 83.433z",
    fill: "#bed8fb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#617881"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m441.963 240.032h-280.919c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h280.919c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.963 281.131h-280.919c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h280.919c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.963 322.23h-280.919c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h280.919c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.239 363.329h-103.195c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h103.195c4.268 0 7.726 3.459 7.726 7.726.001 4.267-3.458 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.239 126.039h-103.195c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h103.195c4.268 0 7.726 3.459 7.726 7.726.001 4.266-3.458 7.726-7.726 7.726z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m116.724 270.538-111.713 193.493c-12.309 21.319 3.077 47.969 27.695 47.969h223.426c24.618 0 40.004-26.65 27.695-47.969l-111.713-193.493c-12.309-21.32-43.081-21.32-55.39 0z",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.419 428.291c-4.268 0-7.726-3.459-7.726-7.726v-93.39c0-4.267 3.459-7.726 7.726-7.726 4.268 0 7.726 3.459 7.726 7.726v93.39c0 4.266-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.421 471.709c-6.867 0-10.316-8.735-5.241-13.415 2.283-2.105 5.738-2.614 8.542-1.296 3.078 1.447 4.887 4.9 4.318 8.256-.622 3.667-3.888 6.455-7.619 6.455z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m144.415 254.547c-7.108 0-14.206 5.326-18.265 15.988l-73.689 193.5c-8.118 21.314 2.029 47.965 18.265 47.965h-38.024c-24.621 0-40.002-26.651-27.691-47.965l111.713-193.499c6.15-10.662 16.915-15.989 27.691-15.989z",
    fill: "#da4a54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentErrorIcon);
export default __webpack_public_path__ + "static/media/document-error-icon.2af66d1cf3f33b5663ee7efde931dc60.svg";
export { ForwardRef as ReactComponent };